/**
 * `TripService` → a `VoucherDocumentView` que o `VoucherDocument` do intelligence-ui-kit desenha.
 *
 * A derivação de verdade mora em `@voll-intelligence/trip-document`
 * (`buildVoucherDocumentView`), compartilhada com a lane de PDF: este arquivo é só o
 * adaptador que amarra o `t()`/locale do web-chat ao `ctx` que o pacote pede.
 */
import type { ApprovalRequestContext } from '@voll-intelligence/domain';
import {
  buildVoucherDocumentView as build,
  type TripService,
  type VoucherDocumentView,
} from '@voll-intelligence/trip-document';
export { voucherShareText } from '@voll-intelligence/trip-document';
import { documentCtx } from './document_ctx.js';

/** Thin adapter: injeta o `t()`/locale do web-chat (via `documentCtx()`) na
 *  derivação real do pacote — nenhuma lógica própria mora aqui. */
export function buildVoucherDocumentView(
  service: TripService,
  request?: ApprovalRequestContext,
): VoucherDocumentView {
  return build(service, documentCtx(), request);
}
